"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertEntityInstance = exports.assertType = void 0;
const tslib_1 = require("tslib");
const assert_1 = tslib_1.__importDefault(require("assert"));
function assertType(typeGuard, value, error) {
    assert_1.default(typeGuard(value), error !== null && error !== void 0 ? error : new Error(`expected ${typeGuard.name} to return true for value: ${JSON.stringify(value)}`));
}
exports.assertType = assertType;
function assertEntityInstance(entity, entityClass) {
    assert_1.default(entity instanceof entityClass, `expected entity to be instanceof ${entityClass.name}, entity: ${JSON.stringify(entity)}`);
}
exports.assertEntityInstance = assertEntityInstance;
//# sourceMappingURL=assert-type.js.map